import { Component, inject, Input } from '@angular/core';
import { MenuLateralService } from 'src/app/components/menu-lateral/data/menu-lateral.service';
import { MenuLateralOptions } from './data/menu-lateral-options';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-menu-lateral-options',
	standalone: true,
	imports: [],
	templateUrl: './menu-lateral-options.component.html',
	styleUrl: './menu-lateral-options.component.scss',
})
export class MenuLateralOptionsComponent {
	protected readonly menuLateralService = inject(MenuLateralService);
	MenuLateralOptions = MenuLateralOptions;

	@Input() labels: LabelsInterface = {};

	setMenuLateralViewMode(value: 'alwaysOpen' | 'alwaysClosed' | 'hoverOpen' | 'hamburgerOpen') {
		this.menuLateralService.menuLateralViewMode.set(value);
		localStorage.setItem('menuLateralViewMode', value);
	}
}
